import { render, staticRenderFns } from "./ModalVideosYoutube.vue?vue&type=template&id=285890c8&scoped=true&"
import script from "./ModalVideosYoutube.vue?vue&type=script&lang=js&"
export * from "./ModalVideosYoutube.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideosYoutube.vue?vue&type=style&index=0&id=285890c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285890c8",
  null
  
)

export default component.exports